export default "__VITE_ASSET__B4uRe5RQ__"